import { render } from "./ExpedicionesRepartoEnCursoPage.vue?vue&type=template&id=33045dd5&scoped=true"
import script from "./ExpedicionesRepartoEnCursoPage.vue?vue&type=script&lang=js"
export * from "./ExpedicionesRepartoEnCursoPage.vue?vue&type=script&lang=js"

import "./ExpedicionesRepartoEnCursoPage.vue?vue&type=style&index=0&id=33045dd5&scoped=true&lang=scss"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33045dd5"]])

export default __exports__